import { render, staticRenderFns } from "./ExemptionPaymentInfo.vue?vue&type=template&id=466a3bb8"
import script from "./ExemptionPaymentInfo.vue?vue&type=script&lang=ts"
export * from "./ExemptionPaymentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports